module.exports = __webpack_public_path__ + "img/sp_02.0c6b5ce6.png";